import React from "react";
import uploadIcon from "../../assets/images/upload.png";
import checkIcon from "../../assets/images/icons/check_icon.png";

const UploadJson = ({
  onOpenModal2,
  onClose,
  onFileUpload,
  fileName,
  errorMessage,
}) => {
  return (
    <>
      <div
        className="modal fade show"
        aria-labelledby="UploadJsonLabel"
        aria-hidden="true"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h3
                className="modal-title text-center w-100"
                id="UploadJsonLabel"
              >
                Upload Your JSON File
              </h3>
            </div>

            <div className="modal-body text-center">
              <p className="mb-4">
                Please upload your JSON file using the icon below.
              </p>

              <div
                className="border p-4 mb-4 hover-shadow"
                style={{
                  borderRadius: "8px",
                  borderColor: "#ccc",
                  borderWidth: "2px",
                }}
              >
                <label htmlFor="jsonFile">
                  <img
                    src={uploadIcon}
                    alt="Upload Icon"
                    className="img-fluid mb-3"
                    style={{ width: "150px", cursor: "pointer" }}
                  />
                </label>
                <input
                  className="form-control d-none"
                  type="file"
                  id="jsonFile"
                  accept=".json"
                  onChange={onFileUpload}
                />

                {fileName && (
                  <div className="mt-3 d-flex align-items-center justify-content-center">
                    <input
                      type="text"
                      className="form-control text-center"
                      value={fileName}
                      readOnly
                      style={{ maxWidth: "200px" }}
                    />
                    <img
                      src={checkIcon}
                      alt="Success Tick Icon"
                      className="ms-2"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </div>
                )}
              </div>

              {errorMessage && (
                <div className="alert alert-danger">{errorMessage}</div>
              )}

              <ul className="text-muted list-unstyled text-start">
                <li>• Ensure your file is in valid JSON format.</li>
                <li>• File size should be less than 50MB.</li>
                <li>• If you encounter issues, please verify your file.</li>
              </ul>
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={onOpenModal2}
                disabled={!fileName}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>

      <style jsx>{`
        .hover-shadow:hover {
          background-color: #f8f9fa; /* Bootstrap off-white background */
        }
      `}</style>
    </>
  );
};

export default UploadJson;
